import z from 'zod';

export const MyEmergencyPlanGetPlanDeepLinkSchema = z.object({
  token: z.string(),
});

export type MyEmergencyPlanGetPlanDeepLinkSchema = z.infer<typeof MyEmergencyPlanGetPlanDeepLinkSchema>;
